module.exports = __webpack_public_path__ + "img/12.f5675d26.svg";